import styled, {css} from 'styled-components';
import { Fonts, Colors } from 'common/Theme';
import Helpers from 'common/Theme/Helpers';

export const WrapStyle = styled.div`
  ${Helpers.css.flex_no_shrink};
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  height: 265px;
  width: 48%;
  margin-bottom: 13px;
  overflow: hidden;
  //margin-bottom
  ${props => props.mb && css`
      margin-bottom: ${Helpers.css.mb[props.mb]};
  `}
  //end margin-bottom
  
`;

export const ButtonWrapStyle = styled.div`
  padding: 8px 6px 6px;
`;

export const ImageWrapStyle = styled.div`
  ${Helpers.fullWidth};
  height: 165px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
`;

export const TextWrapStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  ${Helpers.css.flex_sb};
  ${Helpers.css.flex_grow};
  padding: 8px 10px 0;
`;

export const WrapMiniStyle = styled.div`
  ${Helpers.css.flex_no_shrink};
  ${Helpers.css.flex_ac};
  ${Helpers.css.flex_sb};
  ${Helpers.css.flex};
  background: #FFFFFF;
  height: 70px;
  width: 200px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 15px;
  padding: 8px 10px 6px;
  margin-right: 28px;
  position: relative;
`;

export const TextWrapMiniStyle = styled.div`
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  ${Helpers.css.flex_sb};
  ${Helpers.css.flex_grow};
  height: 100%;
`;

export const ImageWrapMiniStyle = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
`;

export const ButtonMiniStyle = styled.div`
  ${Helpers.css.item_vertical};
  right: -14px;   
`;

export const WrapSecondStyle = styled.div`
  ${Helpers.css.flex_no_shrink};
  ${Helpers.css.flex};
  ${Helpers.css.flex_vertical};
  background: #FFFFFF;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
  border-radius: 16px;
  height: 204px;
  width: 31.2%;
  margin-bottom: 13px;
  overflow: hidden;
  cursor: pointer;
  //margin-bottom
  ${props => props.mb && css`
      margin-bottom: ${Helpers.css.mb[props.mb]};
  `}
      //end margin-bottom
  ${props => props.isElementFound && css`
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);

    animation-name: stretch;
    animation-duration: 1.5s;
    animation-timing-function: ease-out;
    animation-direction: alternate;
    //animation-iteration-count: revert;
    animation-play-state: running; 
  `}

  @media (min-width: 768px) {
    width: 23%;
    margin-bottom: 2.6%;
  }

  @keyframes stretch {
    0% {
      transform: scale(.96);
    }

    50% {
      transform: scale(1.02);
    }

    100% {
      transform: scale(1);
    }
  }
`;

export const ImageSecondWrapStyle = styled.div`
  ${Helpers.fullSize};
  max-height: 105px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  img{
    border-radius: 16px;
    transition: all 0.3s ease 0s;
    &:hover {
      transform: scale(1.05);
    }

    &:active {
      transform: scale(1);
      transition: all 0.3s ease 0s;
    }
  }
`;

export const ButtonSecondWrapStyle = styled.div`
  padding: 8px 6px 6px;  
`;

export const TitleSecondWrapStyle = styled.div`
  margin-bottom: 8px;
  
  &:last-child{
    margin-bottom: unset;
  }
`;